import React from "react";

function ExpiredPaymentLink() {
  return (
    <svg
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect width="32" height="32" fill="#FFF1F0" rx="8"></rect>
      <path
        stroke="#F5222D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="M18.026 22.325h-8.8a2.2 2.2 0 01-2.2-2.2v-8.25a2.2 2.2 0 012.2-2.2h13.2a2.2 2.2 0 012.2 2.2v3.85m-17.05-2.2h16.5m-2.377 8.598l1.638-1.637m0 0l1.637-1.637m-1.637 1.637l-1.638-1.637m1.638 1.637l1.637 1.637"
      ></path>
    </svg>
  );
}

export default ExpiredPaymentLink;